import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/workplace-xg/workplace-xg/node_modules/gatsby-theme-carbon/src/templates/Default.js";
import Divider from "../../../components/Divider";
import TwoSections from "../../../components/TwoSections";
import TwoSectionsImages from "../../../components/TwoSectionsImages";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const PageDescription = makeShortcode("PageDescription");
const Row = makeShortcode("Row");
const Column = makeShortcode("Column");
const GifPlayer = makeShortcode("GifPlayer");
const Video = makeShortcode("Video");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <PageDescription mdxType="PageDescription">
      <p>{`Arrival and departure areas are both the first and last moments that clients, IBM employees and guests engage with an IBM site. The experience from the security gate to the Welcome zone should be considered part of our workplace journey.`}</p>
    </PageDescription>
    <Row mdxType="Row">
      <Column mdxType="Column">
        <GifPlayer className="video-player" mdxType="GifPlayer">
          <Video autoPlay playsInline loop="on" muted src="/workplace-xg/410c7da2a624c81c5b39e61e8aec9be5/arrival.mp4" mdxType="Video" />
          <span {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "1152px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "56.25%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAALABQDASIAAhEBAxEB/8QAGAAAAgMAAAAAAAAAAAAAAAAAAAIDBAX/xAAVAQEBAAAAAAAAAAAAAAAAAAABAv/aAAwDAQACEAMQAAABidbUuQKJ/8QAGxAAAQQDAAAAAAAAAAAAAAAAAgABAyERIjL/2gAIAQEAAQUCEtpjfDPUfcliv//EABURAQEAAAAAAAAAAAAAAAAAABAR/9oACAEDAQE/Aaf/xAAVEQEBAAAAAAAAAAAAAAAAAAABEP/aAAgBAgEBPwEJ/8QAGRAAAwADAAAAAAAAAAAAAAAAAAEQESEy/9oACAEBAAY/Amc4jNz/xAAaEAEBAQADAQAAAAAAAAAAAAABEQAhMUFR/9oACAEBAAE/IUPkHWBNWd6gcC3uNzkZ4Zv/2gAMAwEAAgADAAAAEKz/AP/EABURAQEAAAAAAAAAAAAAAAAAAAEQ/9oACAEDAQE/EFT/xAAVEQEBAAAAAAAAAAAAAAAAAAABEP/aAAgBAgEBPxAJ/8QAHBABAQADAAMBAAAAAAAAAAAAAREAITFBcYHR/9oACAEBAAE/ENkUUj1+514DXmHMvHULikmgA/MALQkcNBoNGf/Z')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<img parentName="span" {...{
              "className": "gatsby-resp-image-image",
              "alt": "animation of several arrival zones",
              "title": "animation of several arrival zones",
              "src": "/workplace-xg/static/2e58bd579d4557620ac54817bb2352a7/2e753/wood-slat-wall-elevator-lobby-arrival-zone.jpg",
              "srcSet": ["/workplace-xg/static/2e58bd579d4557620ac54817bb2352a7/69549/wood-slat-wall-elevator-lobby-arrival-zone.jpg 288w", "/workplace-xg/static/2e58bd579d4557620ac54817bb2352a7/473e3/wood-slat-wall-elevator-lobby-arrival-zone.jpg 576w", "/workplace-xg/static/2e58bd579d4557620ac54817bb2352a7/2e753/wood-slat-wall-elevator-lobby-arrival-zone.jpg 1152w", "/workplace-xg/static/2e58bd579d4557620ac54817bb2352a7/74f4b/wood-slat-wall-elevator-lobby-arrival-zone.jpg 1728w", "/workplace-xg/static/2e58bd579d4557620ac54817bb2352a7/f35b7/wood-slat-wall-elevator-lobby-arrival-zone.jpg 1856w"],
              "sizes": "(max-width: 1152px) 100vw, 1152px",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              },
              "loading": "lazy"
            }}></img>{`
    `}</span>
        </GifPlayer>
      </Column>
    </Row>
    <h2>{`Signature moments`}</h2>
    <p>{`Arrival zones vary in size and scale. Some of our Arrival locations may only include an elevator lobby in a multitenant building. Others involve complex campus environments with multiple buildings and business functions. Regardless of size, Arrival zones serve as a transition space between public environments and IBM spaces. Clear signage and wayfinding are critical to guide visitors along a path. Thoughtful application of pattern, lighting and finishes can also reinforce a sense of place.`}</p>
    <Divider mdxType="Divider" />
    <TwoSections title="Finish palette" mdxType="TwoSections">
  <Column colLg={12} colMd={8} colSm={4} mdxType="Column">
    
  For Arrival zones that include shared elevator lobbies that may belong to a building landlord, work with IBM Global Real Estate to identify which components of the shared space IBM can design or influence. Our Arrival spaces should feel warm and inviting. Contrast natural finishes, such as wood, stone or concrete, with engineered materials, such as glass and metal. Emphasize transparency with clear sight lines to the Welcome zone.
  </Column>
  <Column colLg={12} colMd={8} colSm={4} mdxType="Column">
        <span {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "1152px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "100%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAAUABQDASIAAhEBAxEB/8QAGAABAAMBAAAAAAAAAAAAAAAAAAIEBQH/xAAWAQEBAQAAAAAAAAAAAAAAAAAAAQL/2gAMAwEAAhADEAAAAY2KPc3SZzU0b4SB/8QAGhAAAgMBAQAAAAAAAAAAAAAAAAECAxIEMv/aAAgBAQABBQIr8DZqxLdxHnqIRUUf/8QAFREBAQAAAAAAAAAAAAAAAAAAASD/2gAIAQMBAT8BWP/EABYRAQEBAAAAAAAAAAAAAAAAAAERIP/aAAgBAgEBPwEJj//EAB0QAAECBwAAAAAAAAAAAAAAAAAQEQEiMTJBcZH/2gAIAQEABj8CWpK7aM8LRoJ//8QAHhAAAgEDBQAAAAAAAAAAAAAAAAERECFhQVGBocH/2gAIAQEAAT8htIu7UhCLR3EwUnIYhmP1gY1wlT//2gAMAwEAAgADAAAAEL8APP/EABYRAAMAAAAAAAAAAAAAAAAAAAERIP/aAAgBAwEBPxBgj//EABURAQEAAAAAAAAAAAAAAAAAAAEg/9oACAECAQE/EGUf/8QAHxABAAIBAwUAAAAAAAAAAAAAAQARITFBUWGRocHw/9oACAEBAAE/ENS+YDhhaCmbvpF4KutCH2FxVXeoCfPxBUHfd7S6ArC+Qit6z//Z')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": "arrival zone finish palette",
            "title": "arrival zone finish palette",
            "src": "/workplace-xg/static/e1c7832c55ecbb35374a610c957f4425/2e753/arrival-zone-finish-palette.jpg",
            "srcSet": ["/workplace-xg/static/e1c7832c55ecbb35374a610c957f4425/69549/arrival-zone-finish-palette.jpg 288w", "/workplace-xg/static/e1c7832c55ecbb35374a610c957f4425/473e3/arrival-zone-finish-palette.jpg 576w", "/workplace-xg/static/e1c7832c55ecbb35374a610c957f4425/2e753/arrival-zone-finish-palette.jpg 1152w", "/workplace-xg/static/e1c7832c55ecbb35374a610c957f4425/efa0b/arrival-zone-finish-palette.jpg 1214w"],
            "sizes": "(max-width: 1152px) 100vw, 1152px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy"
          }}></img>{`
    `}</span>
  </Column>
    </TwoSections>
    <Divider mdxType="Divider" />
    <TwoSections title="Brand expression" mdxType="TwoSections">
      <Column colLg={12} colMd={8} colSm={4} mdxType="Column">
        <p>{`IBM signage should be placed in a clear and prominent location to aid in wayfinding for visitors. Exterior signage should be placed at key navigational moments for vehicles or pedestrian paths. Proportional relationships of our exterior signage are defined by the 2x Grid. Select materials that complement the surrounding landscape while maintaining clear legibility. The IBM Plex® typeface should be used for all interior and exterior directional signage. Interior identity signage should be die-cut and flush mounted to the wall. Finish and material choice should be selected based on the surrounding space or existing conditions. Avoid placing the IBM logo on a plaque or backer plate whenever possible. Learn more about our `}<a parentName="p" {...{
            "href": "/workplace-xg/brand-expression/signage"
          }}>{`signage guidance`}</a>{`.`}</p>
      </Column>
  <TwoSectionsImages mdxType="TwoSectionsImages">
  <Column colLg={6} colMd={4} colSm={4} mdxType="Column">
          <span {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "576px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "100%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAAUABQDASIAAhEBAxEB/8QAGAABAQEBAQAAAAAAAAAAAAAAAAIBAwT/xAAZAQACAwEAAAAAAAAAAAAAAAABAgADBAX/2gAMAwEAAhADEAAAAfNvOuhnlK1ZwjAD/8QAGhAAAgIDAAAAAAAAAAAAAAAAAAECERASIP/aAAgBAQABBQJIrCkkbl8f/8QAFxEAAwEAAAAAAAAAAAAAAAAAABAREv/aAAgBAwEBPwHBH//EABcRAQEBAQAAAAAAAAAAAAAAAAECIDH/2gAIAQIBAT8BboeY/8QAFhAAAwAAAAAAAAAAAAAAAAAAECBB/9oACAEBAAY/AjW//8QAHBABAAICAwEAAAAAAAAAAAAAAQARITEgQVGB/9oACAEBAAE/IUdEX4xwzYdrxKmhjk1f3h//2gAMAwEAAgADAAAAECs3Qv/EABYRAQEBAAAAAAAAAAAAAAAAAAERIP/aAAgBAwEBPxACVcP/xAAXEQEBAQEAAAAAAAAAAAAAAAABABEQ/9oACAECAQE/EGAah0nn/8QAGhABAAMBAQEAAAAAAAAAAAAAAQARITFBcf/aAAgBAQABPxA+1S6sIH7Vz2FQSk6MAO4csyLFfaYmAHSAsqKp6lxZc//Z')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<img parentName="span" {...{
              "className": "gatsby-resp-image-image",
              "alt": "IBM logo brand expression",
              "title": "IBM logo brand expression",
              "src": "/workplace-xg/static/670ee1db792aace7ab99012aa1c4bbf6/473e3/ibm-logo-brand-expression.jpg",
              "srcSet": ["/workplace-xg/static/670ee1db792aace7ab99012aa1c4bbf6/69549/ibm-logo-brand-expression.jpg 288w", "/workplace-xg/static/670ee1db792aace7ab99012aa1c4bbf6/473e3/ibm-logo-brand-expression.jpg 576w"],
              "sizes": "(max-width: 576px) 100vw, 576px",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              },
              "loading": "lazy"
            }}></img>{`
    `}</span>
  </Column>
  <Column colLg={6} colMd={4} colSm={4} mdxType="Column">
          <span {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "576px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "100%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAAUABQDASIAAhEBAxEB/8QAFwABAQEBAAAAAAAAAAAAAAAAAAIEA//EABQBAQAAAAAAAAAAAAAAAAAAAAD/2gAMAwEAAhADEAAAAd2e+ZvSKkKB/8QAGxAAAQQDAAAAAAAAAAAAAAAAAwABAhESEyD/2gAIAQEAAQUCktlSRnpgix5//8QAFBEBAAAAAAAAAAAAAAAAAAAAIP/aAAgBAwEBPwEf/8QAFBEBAAAAAAAAAAAAAAAAAAAAIP/aAAgBAgEBPwEf/8QAHBAAAQMFAAAAAAAAAAAAAAAAAQACIRASIDFB/9oACAEBAAY/AkAJNI3xXOlxx//EABoQAAMAAwEAAAAAAAAAAAAAAAABERAhQWH/2gAIAQEAAT8haDgVeIo/WraT0rbOp4aJj//aAAwDAQACAAMAAAAQo8cA/8QAFBEBAAAAAAAAAAAAAAAAAAAAIP/aAAgBAwEBPxAf/8QAFBEBAAAAAAAAAAAAAAAAAAAAIP/aAAgBAgEBPxAf/8QAGxABAQADAQEBAAAAAAAAAAAAAQARITFBUWH/2gAIAQEAAT8QoT63TcPV+Ea6iai8AzmOjdh5+EGonpAIv//Z')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<img parentName="span" {...{
              "className": "gatsby-resp-image-image",
              "alt": "arrival zone IBM brand expression",
              "title": "arrival zone IBM brand expression",
              "src": "/workplace-xg/static/b3e3512f5d10edbd4f17b6a7db9d4534/473e3/arrival-zone-ibm-brand-expression.jpg",
              "srcSet": ["/workplace-xg/static/b3e3512f5d10edbd4f17b6a7db9d4534/69549/arrival-zone-ibm-brand-expression.jpg 288w", "/workplace-xg/static/b3e3512f5d10edbd4f17b6a7db9d4534/473e3/arrival-zone-ibm-brand-expression.jpg 576w"],
              "sizes": "(max-width: 576px) 100vw, 576px",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              },
              "loading": "lazy"
            }}></img>{`
    `}</span>
  </Column>
  <Column colLg={6} colMd={4} colSm={4} mdxType="Column">
          <span {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "576px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "100%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAAUABQDASIAAhEBAxEB/8QAGQABAAMBAQAAAAAAAAAAAAAAAAEDBQQG/8QAFAEBAAAAAAAAAAAAAAAAAAAAAP/aAAwDAQACEAMQAAAB7M23HPXoFEhaD//EABsQAAICAwEAAAAAAAAAAAAAAAECAAMEEBET/9oACAEBAAEFArrvKHLsJmceQHrSypLIqKuv/8QAFBEBAAAAAAAAAAAAAAAAAAAAIP/aAAgBAwEBPwEf/8QAFBEBAAAAAAAAAAAAAAAAAAAAIP/aAAgBAgEBPwEf/8QAHBAAAQUAAwAAAAAAAAAAAAAAAQACEBEhEiIx/9oACAEBAAY/AhnqyhDEIHIXS6tAj//EAB4QAQABBAIDAAAAAAAAAAAAAAERABAhMUFRcYGh/9oACAEBAAE/ISGzLbFCgGvU2he1JGyzxbwDK+OBb//aAAwDAQACAAMAAAAQkA8A/8QAFBEBAAAAAAAAAAAAAAAAAAAAIP/aAAgBAwEBPxAf/8QAFBEBAAAAAAAAAAAAAAAAAAAAIP/aAAgBAgEBPxAf/8QAHBABAAMAAwEBAAAAAAAAAAAAAQARITFRYUFx/9oACAEBAAE/EEdDwwFV49wTIDLOe2LrGSVd8y/hCgWFoe9QfZhO5QrlwyvwYgE//9k=')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<img parentName="span" {...{
              "className": "gatsby-resp-image-image",
              "alt": "IBM arrival zone brand expression",
              "title": "IBM arrival zone brand expression",
              "src": "/workplace-xg/static/6da7dc7d639e012e190155bd8a16d24f/473e3/ibm-arrival-zone-brand-expression.jpg",
              "srcSet": ["/workplace-xg/static/6da7dc7d639e012e190155bd8a16d24f/69549/ibm-arrival-zone-brand-expression.jpg 288w", "/workplace-xg/static/6da7dc7d639e012e190155bd8a16d24f/473e3/ibm-arrival-zone-brand-expression.jpg 576w"],
              "sizes": "(max-width: 576px) 100vw, 576px",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              },
              "loading": "lazy"
            }}></img>{`
    `}</span>
  </Column>
  <Column colLg={6} colMd={4} colSm={4} mdxType="Column">
          <span {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "576px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "100%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAAUABQDASIAAhEBAxEB/8QAGQABAAIDAAAAAAAAAAAAAAAAAAMFAQIE/8QAFAEBAAAAAAAAAAAAAAAAAAAAAP/aAAwDAQACEAMQAAABu8QcxaNBIAD/xAAbEAACAwADAAAAAAAAAAAAAAABAgADERATFP/aAAgBAQABBQIuqzsWA7La2c+ZsQYnP//EABQRAQAAAAAAAAAAAAAAAAAAACD/2gAIAQMBAT8BH//EABQRAQAAAAAAAAAAAAAAAAAAACD/2gAIAQIBAT8BH//EABsQAAICAwEAAAAAAAAAAAAAAAABITERIDJB/9oACAEBAAY/ApaR0iCMV6WhJ6f/xAAbEAEAAwEAAwAAAAAAAAAAAAABABExQSBRYf/aAAgBAQABPyFinPrBc9uwAKsewimtiLQIbkSqWHPD/9oADAMBAAIAAwAAABDwwAD/xAAUEQEAAAAAAAAAAAAAAAAAAAAg/9oACAEDAQE/EB//xAAUEQEAAAAAAAAAAAAAAAAAAAAg/9oACAECAQE/EB//xAAbEAEAAgMBAQAAAAAAAAAAAAABABEhMUGBIP/aAAgBAQABPxAikFgA1NksOB0dgdRWBsY1SLtrt8hQNGSbV441BgBhNPPj/9k=')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<img parentName="span" {...{
              "className": "gatsby-resp-image-image",
              "alt": "Wall mounted IBM logo brand expression",
              "title": "Wall mounted IBM logo brand expression",
              "src": "/workplace-xg/static/9c820e164273b2685873666d57f97907/473e3/wall-mounted-ibm-logo-brand-expression.jpg",
              "srcSet": ["/workplace-xg/static/9c820e164273b2685873666d57f97907/69549/wall-mounted-ibm-logo-brand-expression.jpg 288w", "/workplace-xg/static/9c820e164273b2685873666d57f97907/473e3/wall-mounted-ibm-logo-brand-expression.jpg 576w"],
              "sizes": "(max-width: 576px) 100vw, 576px",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              },
              "loading": "lazy"
            }}></img>{`
    `}</span>
  </Column>
  <Column mdxType="Column">
          <span {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "1152px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "56.25%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAALABQDASIAAhEBAxEB/8QAGQAAAQUAAAAAAAAAAAAAAAAAAAECAwQG/8QAFAEBAAAAAAAAAAAAAAAAAAAAAP/aAAwDAQACEAMQAAABqSt0ICh//8QAGRABAAMBAQAAAAAAAAAAAAAAAgABAxEx/9oACAEBAAEFAuzLdFBdOdVaANV5P//EABQRAQAAAAAAAAAAAAAAAAAAABD/2gAIAQMBAT8BP//EABQRAQAAAAAAAAAAAAAAAAAAABD/2gAIAQIBAT8BP//EABkQAAMAAwAAAAAAAAAAAAAAAAABIRARQf/aAAgBAQAGPwI1zFIkQ//EABoQAQEBAQADAAAAAAAAAAAAAAERACFBYYH/2gAIAQEAAT8hk75zsFXZ70ZwsFMCBfMgmJv/2gAMAwEAAgADAAAAEGvv/8QAFBEBAAAAAAAAAAAAAAAAAAAAEP/aAAgBAwEBPxA//8QAFREBAQAAAAAAAAAAAAAAAAAAARD/2gAIAQIBAT8QZ//EABsQAQADAQADAAAAAAAAAAAAAAEAESFhQVGR/9oACAEBAAE/EFlBBojVQzG4D652GacYffDIXNDxAsAW0Pc//9k=')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<img parentName="span" {...{
              "className": "gatsby-resp-image-image",
              "alt": "hallway wall brand expression",
              "title": "hallway wall brand expression",
              "src": "/workplace-xg/static/2bdd7d8556df53f2f7fa960d8f9124db/2e753/hallway-wall-brand-expression.jpg",
              "srcSet": ["/workplace-xg/static/2bdd7d8556df53f2f7fa960d8f9124db/69549/hallway-wall-brand-expression.jpg 288w", "/workplace-xg/static/2bdd7d8556df53f2f7fa960d8f9124db/473e3/hallway-wall-brand-expression.jpg 576w", "/workplace-xg/static/2bdd7d8556df53f2f7fa960d8f9124db/2e753/hallway-wall-brand-expression.jpg 1152w", "/workplace-xg/static/2bdd7d8556df53f2f7fa960d8f9124db/a052a/hallway-wall-brand-expression.jpg 1216w"],
              "sizes": "(max-width: 1152px) 100vw, 1152px",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              },
              "loading": "lazy"
            }}></img>{`
    `}</span>
  </Column>
  <Column colLg={6} colMd={4} colSm={4} mdxType="Column">
          <span {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "576px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "151.04166666666669%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAAeABQDASIAAhEBAxEB/8QAGQAAAgMBAAAAAAAAAAAAAAAAAAMBAgUE/8QAFQEBAQAAAAAAAAAAAAAAAAAAAAH/2gAMAwEAAhADEAAAAdUSwg4iGPreME0Sv//EABwQAAEEAwEAAAAAAAAAAAAAAAIAAQMEERIzEP/aAAgBAQABBQLzVRSbhlSWdTq8WHCsdwZhbKKMCL//xAAUEQEAAAAAAAAAAAAAAAAAAAAg/9oACAEDAQE/AR//xAAUEQEAAAAAAAAAAAAAAAAAAAAg/9oACAECAQE/AR//xAAdEAACAgIDAQAAAAAAAAAAAAAAARExAhAhMnGB/9oACAEBAAY/ArZeR2ZMclDSxo+6y9IWpaP/xAAbEAEAAwADAQAAAAAAAAAAAAABABEhEDFR8P/aAAgBAQABPyEJp9EUsdNUZULJdD3Jsv0ta4DUvguhpGGVln//2gAMAwEAAgADAAAAEEAs8v/EABURAQEAAAAAAAAAAAAAAAAAABAR/9oACAEDAQE/ECn/xAAXEQEBAQEAAAAAAAAAAAAAAAABABEQ/9oACAECAQE/EOILtt//xAAfEAEAAgICAgMAAAAAAAAAAAABABEhMUFRYXGRscH/2gAIAQEAAT8QcPoCJX4RcKfiAyG2sIvh5gitOTSImlW2Xg6hwsvZieBorHu4FU7Q0VOiNW2EOVy9z//Z')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<img parentName="span" {...{
              "className": "gatsby-resp-image-image",
              "alt": "IBM Quantum platform render in elevator lobby",
              "title": "IBM Quantum platform render in elevator lobby",
              "src": "/workplace-xg/static/953d8c9a266182a3aab872312fcbd99b/473e3/quantum-blueprint-wall-art-brand-expression.jpg",
              "srcSet": ["/workplace-xg/static/953d8c9a266182a3aab872312fcbd99b/69549/quantum-blueprint-wall-art-brand-expression.jpg 288w", "/workplace-xg/static/953d8c9a266182a3aab872312fcbd99b/473e3/quantum-blueprint-wall-art-brand-expression.jpg 576w"],
              "sizes": "(max-width: 576px) 100vw, 576px",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              },
              "loading": "lazy"
            }}></img>{`
    `}</span>
  </Column>
  <Column colLg={6} colMd={4} colSm={4} mdxType="Column">
          <span {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "576px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "100%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAAUABQDASIAAhEBAxEB/8QAGAABAQEBAQAAAAAAAAAAAAAAAAIDAQX/xAAVAQEBAAAAAAAAAAAAAAAAAAAAAf/aAAwDAQACEAMQAAAB9vHSIpAroSD/xAAaEAACAgMAAAAAAAAAAAAAAAAAAREhEBJB/9oACAEBAAEFAuKZGi0bCvP/xAAUEQEAAAAAAAAAAAAAAAAAAAAg/9oACAEDAQE/AR//xAAWEQADAAAAAAAAAAAAAAAAAAAAEBH/2gAIAQIBAT8BK//EABkQAAEFAAAAAAAAAAAAAAAAACAAASExUf/aAAgBAQAGPwKA1U4f/8QAHRAAAgIBBQAAAAAAAAAAAAAAAAEQEWEhMUFxgf/aAAgBAQABPyFuwyfYRutHg6hYm5Dj/9oADAMBAAIAAwAAABAXLz7/xAAXEQEAAwAAAAAAAAAAAAAAAAAAARAR/9oACAEDAQE/EGJr/8QAGBEAAgMAAAAAAAAAAAAAAAAAAAEQETH/2gAIAQIBAT8QelBR/8QAHRABAAICAgMAAAAAAAAAAAAAAQARITEQQVFhkf/aAAgBAQABPxC2ULWJd4O4dxjYv3FlovjEN3+i4tsMNcFn/9k=')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<img parentName="span" {...{
              "className": "gatsby-resp-image-image",
              "alt": "brass and solid surface brand expression detail",
              "title": "brass and solid surface brand expression detail",
              "src": "/workplace-xg/static/38adf0575242bbc71f2341446ef50b16/473e3/brass-quantum-art-brand-expression-detail.jpg",
              "srcSet": ["/workplace-xg/static/38adf0575242bbc71f2341446ef50b16/69549/brass-quantum-art-brand-expression-detail.jpg 288w", "/workplace-xg/static/38adf0575242bbc71f2341446ef50b16/473e3/brass-quantum-art-brand-expression-detail.jpg 576w"],
              "sizes": "(max-width: 576px) 100vw, 576px",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              },
              "loading": "lazy"
            }}></img>{`
    `}</span>
  </Column>
  </TwoSectionsImages>
    </TwoSections>
    <Divider mdxType="Divider" />
    <TwoSections title="Outdoor space" mdxType="TwoSections">
  <Column colLg={12} colMd={8} colSm={4} mdxType="Column">
    
  Outdoor spaces can provide a natural buffer between parking and Welcome zones. Ideally, outdoor spaces should be active and connected with adjacent dining or food services. Outdoor landscaping and design should reflect the surrounding environment, using indigenous plants and materials. Frequent access to fresh air and natural light create higher-performing work environments.
  </Column>
  <TwoSectionsImages mdxType="TwoSectionsImages">
  <Column mdxType="Column">
          <span {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "1152px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "66.66666666666666%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAANABQDASIAAhEBAxEB/8QAFgABAQEAAAAAAAAAAAAAAAAAAwQA/8QAFQEBAQAAAAAAAAAAAAAAAAAAAQL/2gAMAwEAAhADEAAAAaAAJLNLh//EABkQAAMBAQEAAAAAAAAAAAAAAAABAwISEf/aAAgBAQABBQLNmWsqJJ+aZ0dn/8QAFhEBAQEAAAAAAAAAAAAAAAAAABEh/9oACAEDAQE/AcV//8QAFREBAQAAAAAAAAAAAAAAAAAAEBH/2gAIAQIBAT8Bp//EABkQAQADAQEAAAAAAAAAAAAAAAABETEh4f/aAAgBAQAGPwK+UqHjIZDH/8QAGxAAAgIDAQAAAAAAAAAAAAAAAAERMSFR0fH/2gAIAQEAAT8hYboOkKiWs2boeIQsoR2f/9oADAMBAAIAAwAAABDLP//EABYRAQEBAAAAAAAAAAAAAAAAAAARAf/aAAgBAwEBPxDIQ//EABURAQEAAAAAAAAAAAAAAAAAABAh/9oACAECAQE/ELP/xAAdEAEBAAICAwEAAAAAAAAAAAABEQBBITFRkaHR/9oACAEBAAE/EH9aB5PTiFQqhR41DDmLPIsa0Ga6/MUVEmy/uEHSGln/2Q==')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<img parentName="span" {...{
              "className": "gatsby-resp-image-image",
              "alt": "outdoor space",
              "title": "outdoor space",
              "src": "/workplace-xg/static/548fe766e97062edda04a52a63f174b1/2e753/outdoor-space.jpg",
              "srcSet": ["/workplace-xg/static/548fe766e97062edda04a52a63f174b1/69549/outdoor-space.jpg 288w", "/workplace-xg/static/548fe766e97062edda04a52a63f174b1/473e3/outdoor-space.jpg 576w", "/workplace-xg/static/548fe766e97062edda04a52a63f174b1/2e753/outdoor-space.jpg 1152w", "/workplace-xg/static/548fe766e97062edda04a52a63f174b1/a052a/outdoor-space.jpg 1216w"],
              "sizes": "(max-width: 1152px) 100vw, 1152px",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              },
              "loading": "lazy"
            }}></img>{`
    `}</span>
  </Column>
  <Column colLg={6} colMd={4} colSm={4} mdxType="Column">
          <span {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "576px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "100%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAAUABQDASIAAhEBAxEB/8QAGAABAAMBAAAAAAAAAAAAAAAAAAIDBAX/xAAXAQEBAQEAAAAAAAAAAAAAAAACAAED/9oADAMBAAIQAxAAAAHnbLrwee3rZ4ycwOn/xAAZEAADAQEBAAAAAAAAAAAAAAABAgMAERT/2gAIAQEAAQUCOZpzPZHedetGbbyrjJACACtmQf/EABYRAQEBAAAAAAAAAAAAAAAAAAEAEP/aAAgBAwEBPwEMFm//xAAVEQEBAAAAAAAAAAAAAAAAAAAQEf/aAAgBAgEBPwEh/8QAHRAAAgIBBQAAAAAAAAAAAAAAABEBAkESITEyM//aAAgBAQAGPwI0q3A1Y9IN7GTqXWIFB//EABwQAQACAwEBAQAAAAAAAAAAAAEAESExQWFR4f/aAAgBAQABPyHZlsM0cJ2NLZ9IGnd5+zN5aOnJpmyhGVEqlKhWpD7P/9oADAMBAAIAAwAAABBH+Lz/xAAYEQEBAQEBAAAAAAAAAAAAAAABABExQf/aAAgBAwEBPxB/SyQdga3/xAAYEQADAQEAAAAAAAAAAAAAAAAAAREhQf/aAAgBAgEBPxDOkQ0pT//EAB0QAQEAAwACAwAAAAAAAAAAAAERACExcZFBYbH/2gAIAQEAAT8Qe9K+cCUNMDA6vnKQqbOH1iEYoSPnC0xBQJAa9ZrAoDTTnrEE06W/uEAkTRGW5FLhJVKDO8z/2Q==')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<img parentName="span" {...{
              "className": "gatsby-resp-image-image",
              "alt": "outdoor space with biophilic elements",
              "title": "outdoor space with biophilic elements",
              "src": "/workplace-xg/static/e3d294349a0e9a86c4fa0a813bc26b82/473e3/outdoor-space-with-biophilic-elements.jpg",
              "srcSet": ["/workplace-xg/static/e3d294349a0e9a86c4fa0a813bc26b82/69549/outdoor-space-with-biophilic-elements.jpg 288w", "/workplace-xg/static/e3d294349a0e9a86c4fa0a813bc26b82/473e3/outdoor-space-with-biophilic-elements.jpg 576w"],
              "sizes": "(max-width: 576px) 100vw, 576px",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              },
              "loading": "lazy"
            }}></img>{`
    `}</span>
  </Column>
  <Column colLg={6} colMd={4} colSm={4} mdxType="Column">
          <span {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "576px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "75%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAAPABQDASIAAhEBAxEB/8QAGQAAAgMBAAAAAAAAAAAAAAAAAAQBAgMF/8QAFQEBAQAAAAAAAAAAAAAAAAAAAQL/2gAMAwEAAhADEAAAAeY0nszBUH//xAAaEAACAwEBAAAAAAAAAAAAAAABAgADERIT/9oACAEBAAEFAkr6grXCsR+YLsHuRP/EABQRAQAAAAAAAAAAAAAAAAAAABD/2gAIAQMBAT8BP//EABURAQEAAAAAAAAAAAAAAAAAABAR/9oACAECAQE/Aaf/xAAZEAADAAMAAAAAAAAAAAAAAAAAATESUYH/2gAIAQEABj8CHOlZsaxRD//EABwQAQACAgMBAAAAAAAAAAAAAAEAESFBMVGRof/aAAgBAQABPyHuUQNQE2swL5YAr6mVG5oH2f/aAAwDAQACAAMAAAAQ++//xAAWEQEBAQAAAAAAAAAAAAAAAAABEBH/2gAIAQMBAT8QDJ//xAAWEQEBAQAAAAAAAAAAAAAAAAAAEQH/2gAIAQIBAT8Q21f/xAAeEAEAAgIBBQAAAAAAAAAAAAABABEhMYFBUXHR8f/aAAgBAQABPxBc2h2LXwe4i0xv8TUu+cfGEwAvqSIQSubcVxC0DLvaf//Z')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<img parentName="span" {...{
              "className": "gatsby-resp-image-image",
              "alt": "exterior night view",
              "title": "exterior night view",
              "src": "/workplace-xg/static/37f419f87ed8edea7d9a247bbcb0f1a1/473e3/exterior-night-view.jpg",
              "srcSet": ["/workplace-xg/static/37f419f87ed8edea7d9a247bbcb0f1a1/69549/exterior-night-view.jpg 288w", "/workplace-xg/static/37f419f87ed8edea7d9a247bbcb0f1a1/473e3/exterior-night-view.jpg 576w"],
              "sizes": "(max-width: 576px) 100vw, 576px",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              },
              "loading": "lazy"
            }}></img>{`
    `}</span>
  </Column>
  </TwoSectionsImages>
    </TwoSections>
    <Divider mdxType="Divider" />
    <TwoSections title="Flooring and ceiling" mdxType="TwoSections">
  <Column colLg={12} colMd={8} colSm={4} mdxType="Column">
    
    <p>As a major point of circulation, Arrival zones should use a durable flooring material, such as polished concrete, terrazzo or stone. </p>
    <p>A linear ceiling system may be used to complement various applications of pattern. This ceiling should serve to ground our signature elements and direct guests towards the Arrival zone. Light fixtures should be integrated within the ceiling system. Linear fixtures and downlights should be lensed, soft and diffused.</p>
  </Column>
  <TwoSectionsImages mdxType="TwoSectionsImages">
  <Column mdxType="Column">
          <span {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "1152px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "33.33333333333333%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAAHABQDASIAAhEBAxEB/8QAFgABAQEAAAAAAAAAAAAAAAAAAAME/8QAFAEBAAAAAAAAAAAAAAAAAAAAAf/aAAwDAQACEAMQAAABvYHAA//EABkQAAEFAAAAAAAAAAAAAAAAAAEAAgQSMv/aAAgBAQABBQJgN5GF/8QAFREBAQAAAAAAAAAAAAAAAAAAARD/2gAIAQMBAT8BZ//EABURAQEAAAAAAAAAAAAAAAAAAAEQ/9oACAECAQE/ASf/xAAYEAACAwAAAAAAAAAAAAAAAAAAARARcf/aAAgBAQAGPwJWLY//xAAaEAACAgMAAAAAAAAAAAAAAAAAAREhMWGh/9oACAEBAAE/IZkyrViSSll8P//aAAwDAQACAAMAAAAQh/8A/8QAFREBAQAAAAAAAAAAAAAAAAAAEDH/2gAIAQMBAT8Qs//EABURAQEAAAAAAAAAAAAAAAAAABAx/9oACAECAQE/EIP/xAAaEAEBAAIDAAAAAAAAAAAAAAABEQAhQVGB/9oACAEBAAE/EKGlNXoecGPRNfHKAUZtRn//2Q==')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<img parentName="span" {...{
              "className": "gatsby-resp-image-image",
              "alt": "linear light grid expression in arrival zone",
              "title": "linear light grid expression in arrival zone",
              "src": "/workplace-xg/static/c35b3e2d0b9aed40c193b6c03f10440e/2e753/linear-light-grid-expression-in-arrival-zone.jpg",
              "srcSet": ["/workplace-xg/static/c35b3e2d0b9aed40c193b6c03f10440e/69549/linear-light-grid-expression-in-arrival-zone.jpg 288w", "/workplace-xg/static/c35b3e2d0b9aed40c193b6c03f10440e/473e3/linear-light-grid-expression-in-arrival-zone.jpg 576w", "/workplace-xg/static/c35b3e2d0b9aed40c193b6c03f10440e/2e753/linear-light-grid-expression-in-arrival-zone.jpg 1152w", "/workplace-xg/static/c35b3e2d0b9aed40c193b6c03f10440e/a052a/linear-light-grid-expression-in-arrival-zone.jpg 1216w"],
              "sizes": "(max-width: 1152px) 100vw, 1152px",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              },
              "loading": "lazy"
            }}></img>{`
    `}</span>
  </Column>
  <Column mdxType="Column">
          <span {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "1000px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "33.33333333333333%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAAHABQDASIAAhEBAxEB/8QAFgABAQEAAAAAAAAAAAAAAAAAAAQB/8QAFAEBAAAAAAAAAAAAAAAAAAAAAv/aAAwDAQACEAMQAAABuqCtCP8A/8QAFhAAAwAAAAAAAAAAAAAAAAAAAhAx/9oACAEBAAEFAhq//8QAFhEAAwAAAAAAAAAAAAAAAAAAARAx/9oACAEDAQE/ARF//8QAFhEAAwAAAAAAAAAAAAAAAAAAARAx/9oACAECAQE/ATV//8QAFBABAAAAAAAAAAAAAAAAAAAAEP/aAAgBAQAGPwJ//8QAGBAAAgMAAAAAAAAAAAAAAAAAABEBECH/2gAIAQEAAT8hxEbr/9oADAMBAAIAAwAAABCAD//EABURAQEAAAAAAAAAAAAAAAAAABAx/9oACAEDAQE/EKH/xAAVEQEBAAAAAAAAAAAAAAAAAAAQMf/aAAgBAgEBPxCJ/8QAGRAAAwADAAAAAAAAAAAAAAAAABEhAUFR/9oACAEBAAE/EFi3DDETh//Z')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<img parentName="span" {...{
              "className": "gatsby-resp-image-image",
              "alt": "flooring and ceiling palette for arrival zone",
              "title": "flooring and ceiling palette for arrival zone",
              "src": "/workplace-xg/static/2dc7e7e7d5da5cc7c599590cc21b3e21/4edc6/flooring-and-ceiling-palette-for-arrival-zone.jpg",
              "srcSet": ["/workplace-xg/static/2dc7e7e7d5da5cc7c599590cc21b3e21/69549/flooring-and-ceiling-palette-for-arrival-zone.jpg 288w", "/workplace-xg/static/2dc7e7e7d5da5cc7c599590cc21b3e21/473e3/flooring-and-ceiling-palette-for-arrival-zone.jpg 576w", "/workplace-xg/static/2dc7e7e7d5da5cc7c599590cc21b3e21/4edc6/flooring-and-ceiling-palette-for-arrival-zone.jpg 1000w"],
              "sizes": "(max-width: 1000px) 100vw, 1000px",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              },
              "loading": "lazy"
            }}></img>{`
    `}</span>
  </Column>
  <Column colLg={6} colMd={4} colSm={4} mdxType="Column">
          <span {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "576px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "151.04166666666669%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAAeABQDASIAAhEBAxEB/8QAGAAAAwEBAAAAAAAAAAAAAAAAAAMEAgX/xAAVAQEBAAAAAAAAAAAAAAAAAAAAAf/aAAwDAQACEAMQAAAB5OnXxIdEIacPGCyX/8QAHhAAAgEDBQAAAAAAAAAAAAAAAQIDBBEhABASMkH/2gAIAQEAAQUCG0cXJY0Dk062CYp+yWM6thF16uB//8QAFxEAAwEAAAAAAAAAAAAAAAAAABAREv/aAAgBAwEBPwFZpD//xAAYEQEAAwEAAAAAAAAAAAAAAAABAAIREP/aAAgBAgEBPwFON8mk/8QAGxAAAgIDAQAAAAAAAAAAAAAAABABcQIRYeH/2gAIAQEABj8CW5I6erGyVT//xAAfEAACAgIBBQAAAAAAAAAAAAAAAREhQVExEJGhseH/2gAIAQEAAT8hrK7dEbQqt2taFpeBUikN8Q6HNim07fsgbh8pEolnZHJyz//aAAwDAQACAAMAAAAQryp8/8QAFhEBAQEAAAAAAAAAAAAAAAAAAQAR/9oACAEDAQE/EBtYc3f/xAAXEQEBAQEAAAAAAAAAAAAAAAAAAREh/9oACAECAQE/EOjIgSz/xAAgEAEBAAIBAwUAAAAAAAAAAAABEQAhUTFhcUGBkbHB/9oACAEBAAE/EEIUQauTHWAHRWpxiA1QDuPXvm3KnUbGDJJEA4y5s0meRkTG5X3xGYoXgEfmRDgiZGr0OC/WPCxKwA/OVR2UY8tz/9k=')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<img parentName="span" {...{
              "className": "gatsby-resp-image-image",
              "alt": "flooring and ceiling in elevator lobby arrival zone",
              "title": "flooring and ceiling in elevator lobby arrival zone",
              "src": "/workplace-xg/static/023ff789572ce9bc86b38474e4f2c2f7/473e3/flooring-and-ceiling-in-elevator-lobby-arrival-zone.jpg",
              "srcSet": ["/workplace-xg/static/023ff789572ce9bc86b38474e4f2c2f7/69549/flooring-and-ceiling-in-elevator-lobby-arrival-zone.jpg 288w", "/workplace-xg/static/023ff789572ce9bc86b38474e4f2c2f7/473e3/flooring-and-ceiling-in-elevator-lobby-arrival-zone.jpg 576w"],
              "sizes": "(max-width: 576px) 100vw, 576px",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              },
              "loading": "lazy"
            }}></img>{`
    `}</span>
  </Column>
  <Column colLg={6} colMd={4} colSm={4} mdxType="Column">
          <span {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "576px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "100%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAAUABQDASIAAhEBAxEB/8QAGAABAQEBAQAAAAAAAAAAAAAAAAMCBAH/xAAWAQEBAQAAAAAAAAAAAAAAAAAAAgH/2gAMAwEAAhADEAAAAfeyFJ2LI6dFzMH/xAAZEAADAQEBAAAAAAAAAAAAAAAAAQIRMRD/2gAIAQEAAQUCnt8JgcD1C80//8QAFBEBAAAAAAAAAAAAAAAAAAAAIP/aAAgBAwEBPwEf/8QAFREBAQAAAAAAAAAAAAAAAAAAESD/2gAIAQIBAT8BI//EABgQAAIDAAAAAAAAAAAAAAAAAAABECAx/9oACAEBAAY/AkOdr//EABoQAQEAAgMAAAAAAAAAAAAAAAEAEZEQUaH/2gAIAQEAAT8h90eg1woiupMwJhGUsob/2gAMAwEAAgADAAAAELvPQf/EABcRAAMBAAAAAAAAAAAAAAAAAAABERD/2gAIAQMBAT8QqLv/xAAYEQACAwAAAAAAAAAAAAAAAAAAARARIf/aAAgBAgEBPxBMbFI//8QAHhABAAICAgMBAAAAAAAAAAAAAQARITFBUWFxkbH/2gAIAQEAAT8Qrt4/sYvoswHb7EBYYkRHlGpVqs6c3Gtj4Lib6iIlyoYfZP/Z')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<img parentName="span" {...{
              "className": "gatsby-resp-image-image",
              "alt": "flooring and ceiling in arrival zone",
              "title": "flooring and ceiling in arrival zone",
              "src": "/workplace-xg/static/7e6a11496795dcd50f15a7d0a3bb3898/473e3/flooring-and-ceiling-in-arrival-zone.jpg",
              "srcSet": ["/workplace-xg/static/7e6a11496795dcd50f15a7d0a3bb3898/69549/flooring-and-ceiling-in-arrival-zone.jpg 288w", "/workplace-xg/static/7e6a11496795dcd50f15a7d0a3bb3898/473e3/flooring-and-ceiling-in-arrival-zone.jpg 576w"],
              "sizes": "(max-width: 576px) 100vw, 576px",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              },
              "loading": "lazy"
            }}></img>{`
    `}</span>
  </Column>
  </TwoSectionsImages>
    </TwoSections>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      